module.exports = {
  "id": "gravity",
  "icon": "appledown",
  "color": "green",
  "title": "gravity",
  "category": "movement",
  "info": [
    {
      "text": "Makes a piece fall until it lands on something solid",
      "image": "provision/glitches/gravity/gravity.gif"
    }
  ],
  "searchTags": ["down","fall","apple","force","weight","heavy","float"],

  "exposedVariables": [
    {
      "tooltip":"Set the strength of gravity for this piece",
      "value": "10",
      "variableName": "gravity strength",
      "spriteName": "$glitch_target",
      "input": {
        "type": "slider",
        "min": "-20",
        "max": "20",
        "options": [],
        "step": ".1",
        "id": "gravity-strength-slider"
      }
    }
  ],
  "codeImage": "provision/glitches/gravity/gravity.png",
  "code": null,
  "zip": null,
  "sb3": null,
  "isRemix": true,
  "image": "provision/parts/gravity/gravity.svg"
};